export enum ExcelTemplateTypes {
    None = "Select a template type...",
    Supplier = "Supplier Pricing Template",
    FloatItem = "Item Float Pricing Template",
    FloatProductLine = "Product Line Float Pricing Template",
    Fixed = "Special Fixed Pricing Template",
    SpecialPricingExpiration = "Special Pricing Expiration Template",
    PromotionExpiration = "Promotion Expiration Template",
    PromotionEntry = "Promotion Entry Template"
}
